/**
 * 填空题类型定义
 */

import { QuestionType } from '../../types';
import type { QuestionTypeMetadata } from '../types';

export const fillBlankTypeMetadata: QuestionTypeMetadata = {
  type: QuestionType.FILL_BLANK,
  name: '填空题',
  description: '需要填写答案的题目',

  requiredFields: ['content', 'correctAnswer'],
  optionalFields: ['explanation', 'difficulty', 'tags', 'imageUrl', 'section', 'level'],

  fields: {
    content: {
      name: 'content',
      type: 'text',
      required: true,
      description: '题目内容（可包含占位符）',
    },
    correctAnswer: {
      name: 'correctAnswer',
      type: 'string',
      required: true,
      description: '正确答案',
      validator: (value) => {
        if (!value || typeof value !== 'string' || value.trim().length === 0) {
          return '正确答案不能为空';
        }
        return true;
      },
    },
    explanation: {
      name: 'explanation',
      type: 'text',
      required: false,
      description: '题目解析',
    },
    imageUrl: {
      name: 'imageUrl',
      type: 'url',
      required: false,
      description: '题目图片URL',
    },
  },

  validate: (question: any) => {
    const errors: any[] = [];

    if (!question.content || typeof question.content !== 'string') {
      errors.push({
        field: 'content',
        message: '题目内容不能为空',
        code: 'MISSING_CONTENT',
      });
    }

    if (
      !question.correctAnswer ||
      typeof question.correctAnswer !== 'string' ||
      question.correctAnswer.trim().length === 0
    ) {
      errors.push({
        field: 'correctAnswer',
        message: '正确答案不能为空',
        code: 'MISSING_ANSWER',
      });
    }

    return {
      valid: errors.length === 0,
      errors,
    };
  },

  renderConfig: {
    layout: 'default',
    showFields: ['content', 'imageUrl'],
  },
};
